const STORAGE_KEY = 'school_branding'

export const DEFAULT_BRANDING = {
  display_name: 'SmartPin',
  primary_color: '#0554B5',
  secondary_color: '#E5454F',
  sidebar_color: '#0F172A',
  logo_url: null as string | null,
}

export function normalizeBranding(value: any = {}) {
  return {
    ...DEFAULT_BRANDING,
    ...value,
    display_name: value.display_name || DEFAULT_BRANDING.display_name,
  }
}

export function storedBranding() {
  try {
    return normalizeBranding(JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'))
  } catch (error) {
    return { ...DEFAULT_BRANDING }
  }
}

export function applyBranding(value: any, vuetify: any) {
  const branding = normalizeBranding(value)
  localStorage.setItem(STORAGE_KEY, JSON.stringify(branding))
  document.documentElement.style.setProperty('--school-primary', branding.primary_color)
  document.documentElement.style.setProperty('--school-secondary', branding.secondary_color)
  document.documentElement.style.setProperty('--school-sidebar', branding.sidebar_color)
  document.title = `${branding.display_name} | SmartPin`

  if (vuetify && vuetify.framework && vuetify.framework.theme) {
    const theme = vuetify.framework.theme.themes.light
    theme.primary = branding.primary_color
    theme.accent = branding.secondary_color
  }

  return branding
}

export function clearBranding(vuetify: any) {
  localStorage.removeItem(STORAGE_KEY)
  return applyBranding(DEFAULT_BRANDING, vuetify)
}
